import { useState, useEffect } from 'react';
import api from '../../../../api';
import { useAuth } from '../../../Layouts/context/Authcontext';
import AreaLineChart from '../../../DashboardComponents/AreaLineChart';
import DashboardWrapper from '../../../DashboardComponents/DashboardWrapper';
import DashboardPercentage from '../../../DashboardComponents/DashboardPercentage';
import BarChart from '../../../DashboardComponents/Barchart';
import UserLevelSummaryComp from './UserLevelSummaryComp';
import UserLevelCardComp from './UserLevelCardComp';
import IconStar from '../../../Icon/IconStar';
import IconCalendar from '../../../Icon/IconCalendar';
import IconChartSquare from '../../../Icon/IconChartSquare';
import KPIRating from './KPI_Rating';
import { getRoundRobinBaseUrl } from '../../../../loadBalancer';

function UserProductionDashboardComp() {
  const [dashboardData, setDashboardData] = useState({});
  const [dailyProductionPercent, setDailyProductionPercent] = useState('0%');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState('daily');
  const [miscMinutes, setMiscMinutes] = useState([]);
  const [attendanceData, setAttendanceData] = useState(null);
  const [dashboardError, setDashboardError] = useState(null);
  const [miscError, setMiscError] = useState(null);
  const [attendanceError, setAttendanceError] = useState(null);
  const [userProductivityData, setUserProductivityData] = useState(null);
  const [weeklyIdleMinutes, setweeklyIdleMins] = useState(null);
  const [totalHoursSpent, setTotalHoursSpent] = useState(null);
  const [realTimeProductionCount, setRealTimeProductionCount] = useState(0);
  const [targetVsAchievedData, setTargetVsAchievedData] = useState({
    categories: [],
    series: [],
  });
  const [productivityChartDataPercent, setProductivityChartDataPercent] = useState({
    series: [],
    categories: [],
  });
  const [productivityChartData, setProductivityChartData] = useState({
    series: [],
    categories: [],
  });
  const [productivityMonthData, setProductivityMonthData] = useState({
    Months: [1, 3, 6],
    Values: [0, 0, 0],
  });
  const [dataType, setDataType] = useState('Epr');

  const cardColors = ['from-[#EE1D23] to-[#EE1D23]', 'from-[#1A2B5C] to-[#1A2B5C]', 'from-[#808080] to-[#808080]'];

  const { accessToken } = useAuth();

  //   const fetchDashboardData = async (month) => {
  //     setDashboardError(null);
  //     try {
  //       let baseUrls = getRoundRobinBaseUrl();
  //       let baseUrl = `${baseUrls}/userDashboard/getUserDashboard`;
  //       let dailyUrl = `${baseUrl}?tab=daily`;
  //       let generalUrl = month !== 'daily' ? `${baseUrl}?tab=${month}` : dailyUrl;
  //       const weeklyProdUrl = `${baseUrls}/userDashboard/getUserWeeklyProduction?tab=${selectedMonth}`;

  //       const headers = {
  //         Authorization: `Bearer ${accessToken}`,
  //       };

  //       const [dailyResponse, generalResponse, weeklyProdResponse] = await Promise.all([
  //         api.get(dailyUrl, { headers }),
  //         api.get(generalUrl, { headers }),
  //         api.get(weeklyProdUrl, { headers }),
  //       ]);

  //       if (dailyResponse.data.success || generalResponse.data.success) {
  //         const dailyProduction = dailyResponse.data?.previousDay?.[0]?.productionPercent || '0%';
  //         setDailyProductionPercent(dailyProduction);
  //         setDashboardData(generalResponse.data);

  //         if (weeklyProdResponse.data.success) {
  //           const rawWeeklyProductivity = weeklyProdResponse.data?.productivityData || {};
  //           const weekCategories = Object.keys(rawWeeklyProductivity);
  //           const weekValues = Object.values(rawWeeklyProductivity).map((val) => parseInt(val));

  //           setProductivityChartData({
  //             series: [{ name: 'Productivity', data: weekValues }],
  //             categories: weekCategories,
  //           });
  //        // Set productivityData for monthly view
  //   const totalCounts = weeklyProdResponse.data?.TotalProductivityCount || {};
  //   setProductivityMonthData({
  //     Months: [1, 3, 6],
  //     Values: [
  //       totalCounts.last1Month || 0,
  //       totalCounts.last3Months || 0,
  //       totalCounts.last6Months || 0,
  //     ],
  //   });
  // }
  //       }
  //     } catch (err) {
  //       console.error('Error fetching dashboard data:', err);
  //       setDashboardError('Failed to fetch dashboard data');
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  const fetchDashboardData = async (month) => {
    setDashboardError(null);
    try {
      let baseUrls = getRoundRobinBaseUrl();
      let baseUrl = `${baseUrls}/userDashboard/getUserDashboard`;
      let dailyUrl = `${baseUrl}?tab=daily&type=${dataType}`;
      let generalUrl = month !== 'daily' ? `${baseUrl}?tab=${month}&type=${dataType}` : dailyUrl;
      const weeklyProdUrl = `${baseUrls}/userDashboard/getUserWeeklyProduction?tab=${selectedMonth}&type=${dataType}`;

      const headers = {
        Authorization: `Bearer ${accessToken}`,
      };

      const [dailyResponse, generalResponse, weeklyProdResponse] = await Promise.all([
        api.get(dailyUrl, { headers }),
        api.get(generalUrl, { headers }),
        api.get(weeklyProdUrl, { headers }),
      ]);

      if (dailyResponse.data.success || generalResponse.data.success) {
        const dailyProduction = dailyResponse.data?.previousDay?.[0]?.productionPercent || '0%';
        setDailyProductionPercent(dailyProduction);
        setDashboardData(generalResponse.data);

        if (weeklyProdResponse.data.success) {
          const rawWeeklyProductivity = weeklyProdResponse.data?.productivityData || {};
          const weekCategories = Object.keys(rawWeeklyProductivity);
          const weekValues = Object.values(rawWeeklyProductivity).map((val) => parseInt(val));

          setProductivityChartData({
            series: [{ name: 'Productivity', data: weekValues }],
            categories: weekCategories,
          });

          const totalCounts = weeklyProdResponse.data?.TotalProductivityCount || {};
          setProductivityMonthData({
            Months: [1, 3, 6],
            Values: [totalCounts.last1Month || 0, totalCounts.last3Months || 0, totalCounts.last6Months || 0],
          });
        }
      }
    } catch (err) {
      console.error('Error fetching dashboard data:', err);
      setDashboardError('Failed to fetch dashboard data');
    } finally {
      setLoading(false);
    }
  };

  const fetchMiscMinutes = async () => {
    setMiscError(null);
    try {
      let baseUrls = getRoundRobinBaseUrl();
      const response = await api.get(`${baseUrls}/userDashboard/getmisc`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      if (response.data.success) {
        setLoading(true);
        setMiscMinutes(response.data?.data?.monthlyDownTime || []);
        setweeklyIdleMins(response.data?.data?.weeklyIdleMinutes);
      }
    } catch (err) {
      setMiscError('Failed to fetch misc minutes');
    } finally {
      setLoading(false);
    }
  };

  const fetchAttendanceData = async () => {
    setAttendanceError(null);
    try {
      let baseUrls = getRoundRobinBaseUrl();
      const response = await api.get(`${baseUrls}/userDashboard/getAttendance`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      if (response.data.success) {
        const data = response?.data?.data[0];
        const attendancePercentage = response?.data;
        setAttendanceData({
          attendance_percentage: attendancePercentage.attendancePercentage,
          total_attendance_days: data.total_attendance_days,
          total_leaves_current_month: response.data.total_leaves_current_month,
        });
        setLoading(true);
      }
    } catch (err) {
      console.error('Error fetching attendance data:', err);
      setAttendanceError('Failed to fetch attendance data');
    } finally {
      setLoading(false);
    }
  };

  // const fetchRealTimeProduction = async () => {
  //   try {
  //     let baseUrls = getRoundRobinBaseUrl();
  //     const response = await api.get(`${baseUrls}/userDashboard/getRealTimeProduction`, {
  //       headers: { Authorization: `Bearer ${accessToken}` },
  //     });
  //     if (response.data.success) {
  //       const count = response.data?.data || 0;
  //       setRealTimeProductionCount(count);
  //       return count;
  //     }
  //   } catch (err) {
  //     console.error('Error fetching real-time production data:', err);
  //     return 0;
  //   }
  // };

  const fetchUserProductivityData = async () => {
    setLoading(true);
    setError(null);
    try {
      let baseUrls = getRoundRobinBaseUrl();
      const response = await api.get(`${baseUrls}/userDashboard/getAllTabs?type=${dataType}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      if (response.data.success) {
        const apiData = response.data;
        // const realTimeProductionValue = await fetchRealTimeProduction();
        const formattedData = {
          card1: [
            {
              MTDProduction: apiData.MTD?.[0]?.productionPercent || '0%',
              LastMonth: apiData?.lastMonthPerformance || 0,
              SuccessPercent: `${apiData.pkt_percentage}%`,
              data: [],
            },
          ],
          card2: [
            {
              MTDProduction: apiData.pkt_percentage || 0,
              LastMonth: apiData.total_points || 0,
              SuccessPercent: '0%',
              data: [],
            },
          ],
          card3: [
            {
              MTDProduction: apiData.toolEffectiveness || '0%',
              LastMonth: apiData.totalLoggedHours || 0,
              SuccessPercent: apiData.totalProductiveHours || '0%',
              data: [],
            },
          ],
          card4: [
            {
              MTDProduction: apiData.realTimeProduction || 0,
              LastMonth: 0,
              SuccessPercent: 'Live',
              data: [],
            },
          ],
        };
        setUserProductivityData(formattedData);
        setTotalHoursSpent(response.data?.totalProductiveHours);
      } else {
        setError('Failed to fetch data');
      }
    } catch (err) {
      console.error('Error fetching user productivity data:', err);
      setError('Failed to fetch data');
    } finally {
      setLoading(false);
    }
  };

  const fetchProductivityPercentage = async () => {
    try {
      let baseUrls = getRoundRobinBaseUrl();
      const response = await api.get(
        `${baseUrls}/userDashboard/getProductionPercentage?tab=${selectedMonth}&type=${dataType}`,
        {
          headers: { Authorization: `Bearer ${accessToken}` },
        }
      );

      if (response.data.success) {
        const percentData = response.data.data || {};
        const categories = Object.keys(percentData);
        const values = Object.values(percentData).map((data) => data.avgProductionPercent);
        setProductivityChartDataPercent({
          series: [{ name: 'Productivity Percentage', data: values }],
          categories: categories,
        });
      }
    } catch (err) {
      console.error('Error fetching productivity percentage data:', err);
    }
  };

  const fetchTargetVsAchievedData = async () => {
    try {
      let baseUrls = getRoundRobinBaseUrl();
      const response = await api.get(`${baseUrls}/userDashboard/getLast7DaysTargetVsAchieved`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      if (response.data.success) {
        const rawData = response.data.last7DaysTargetVsAchieved || {};
        const categories = Object.keys(rawData);
        const targetData = categories.map((date) => rawData[date].target);
        const achievedData = categories.map((date) => rawData[date].achieved);

        setTargetVsAchievedData({
          categories,
          series: [
            { name: 'Target', data: targetData },
            { name: 'Achieved', data: achievedData },
          ],
        });
      }
    } catch (err) {
      console.error('Error fetching Target vs Achieved data:', err);
    }
  };

  useEffect(() => {
    const fetchAllData = async () => {
      try {
        await Promise.all([
          fetchDashboardData(selectedMonth),
          fetchMiscMinutes(),
          fetchAttendanceData(),
          // fetchRealTimeProduction(),
          fetchUserProductivityData(),
          fetchProductivityPercentage(),
          fetchTargetVsAchievedData(),
        ]);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, [selectedMonth, dataType]);

  // const productivityData = {
  //   Months: [1, 3, 6],
  //   Values: [
  //     dashboardData?.lastMonthAchievedCount || 0,
  //     dashboardData?.last3MonthsAchievedCount || 0,
  //     dashboardData?.last6MonthsAchievedCount || 0,
  //   ],
  // };

  return (
    <>
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-gray-500 bg-opacity-50 z-50">
          <div className="w-16 h-16 border-4 border-blue-500 border-t-transparent animate-spin rounded-full"></div>
        </div>
      )}
      <div className="flex justify-center mb-6">
        <div className="inline-flex rounded-full shadow-md overflow-hidden border border-gray-300 bg-white">
          <button
            className={`px-4 py-2 text-sm font-medium ${dataType === 'Epr' ? 'bg-[#EE1D23] text-white' : 'text-gray-700'}`}
            onClick={() => setDataType('Epr')}
          >
            Epr
          </button>
          <button
            className={`px-4 py-2 text-sm font-medium ${dataType === 'Biometrics' ? 'bg-[#1A2B5C] text-white' : 'text-gray-700'}`}
            onClick={() => setDataType('Biometrics')}
          >
            Biometrics
          </button>
        </div>
      </div>

      <div className="grid xl:grid-cols-3 gap-10 mb-3">
        <div className="col-span-1 md:col-span-2 xl:col-span-3 w-full">
          {userProductivityData && <UserLevelCardComp carddata={userProductivityData} />}
        </div>
      </div>

      <div className="grid xl:grid-cols-3 gap-10 mb-6 mt-6">
        {/* Previous Day Productivity */}
        <div className="group relative p-6 rounded-xl bg-gradient-to-br from-[#EE1D23]/90 to-[#b31217] text-white shadow-xl hover:shadow-2xl transition-all duration-300">
          <div className="relative z-10 flex flex-col items-center text-center">
            <IconStar className="w-10 h-10 mb-3" />
            <h3 className="text-md font-semibold uppercase tracking-wide">Previous Day Productivity</h3>
            <p className="text-4xl font-bold mt-1">{dashboardData?.previousDay?.[0]?.productionPercent || '0%'}</p>
          </div>
        </div>

        {/* MTD Productivity */}
        <div className="group relative p-6 rounded-xl bg-gradient-to-br from-[#1A2B5C]/90 to-[#101829] text-white shadow-xl hover:shadow-2xl transition-all duration-300">
          <div className="relative z-10 flex flex-col items-center text-center">
            <IconCalendar className="w-10 h-10 mb-3" />
            <h3 className="text-md font-semibold uppercase tracking-wide">MTD Productivity</h3>
            <p className="text-4xl font-bold mt-1">{dashboardData?.MTD?.[0]?.productionPercent || '0%'}</p>
          </div>
        </div>

        {/* YTD Productivity */}
        <div className="group relative p-6 rounded-xl bg-gradient-to-br from-[#808080]/90 to-[#4d4d4d] text-white shadow-xl hover:shadow-2xl transition-all duration-300">
          <div className="relative z-10 flex flex-col items-center text-center">
            <IconChartSquare className="w-10 h-10 mb-3" />
            <h3 className="text-md font-semibold uppercase tracking-wide">YTD Productivity</h3>
            <p className="text-4xl font-bold mt-1">{dashboardData?.YTD?.[0]?.productionPercent || '0%'}</p>
          </div>
        </div>
      </div>

      <div className="h-auto xl:col-span-2 mt-6 pb-2">
        <UserLevelSummaryComp
          attendanceData={attendanceData}
          weeklyIdleMinutes={weeklyIdleMinutes}
          totalHoursSpent={totalHoursSpent}
        />
      </div>
      <div className="panel p-6 bg-white shadow-lg rounded-lg mb-3 border border-gray-300 mt-6">
        <h2 className="text-2xl font-bold text-center mb-4 text-gray-800">Top 3 Misc Minutes</h2>
        <div className="grid xl:grid-cols-3 gap-6">
          {miscMinutes.slice(0, 3).map((item, index) => (
            <div
              key={index}
              className={`panel p-6 bg-gradient-to-r ${cardColors[index]} shadow-lg rounded-lg text-center text-white transform transition duration-300 hover:scale-105`}
            >
              <h3 className="text-lg font-semibold uppercase tracking-wide">{item._id}</h3>
              <p className="text-3xl font-extrabold">{item.total_duration} mins</p>
            </div>
          ))}
        </div>
      </div>
      <div className="grid xl:grid-cols-4 gap-3 gap-y-2 pb-3 mb-4 mt-6">
        <div className="panel h-full xl:col-span-4">
          <DashboardWrapper
            title="Productivity"
            showMonth={true}
            showDropdown={true}
            monthData={productivityMonthData}
            onMonthChange={setSelectedMonth}
            filterData={productivityMonthData}
          >
            <AreaLineChart dashBoardData={productivityChartData} xTitle="Date" yTitle="Productivity Count" />
          </DashboardWrapper>
        </div>
      </div>
      <div className="grid xl:grid-cols-4 gap-3 gap-y-2 pb-3 mb-4">
        <div className="panel h-full xl:col-span-4">
          <DashboardPercentage
            title="Productivity Percentage"
            showMonth={true}
            showDropdown={true}
            // monthData={productivityData}
            onMonthChange={setSelectedMonth}
            // filterData={productivityData}
          >
            <AreaLineChart dashBoardData={productivityChartDataPercent} xTitle="Date" yTitle="Productivity %" />
          </DashboardPercentage>
        </div>
      </div>
      <div className="grid xl:grid-cols-4 gap-3 gap-y-2 mb-3 mt-6">
        <div className="panel h-full xl:col-span-4">
          <h2 className="text-lg font-semibold mb-2">Target vs Achieved (Last 7 Days)</h2>
          <BarChart data={targetVsAchievedData} />
        </div>
      </div>
      <div className="panel mt-6">
        <KPIRating />
      </div>
    </>
  );
}

export default UserProductionDashboardComp;
